<template>
    <div
        class="pdf-document"
        :class="{ 'is-grab': isGrab, 'is-grabbing': canGrab }"
        @mousedown="handleMouseDown"
        @mouseup="handleMouseUp"
        @mousemove="handleMouseMove"
    >
        <pdf-scroll-document
            v-if="pages.length"
            ref="scroll-document"
            v-bind="{ pages, pageCount, currentPage, scale, isImage, dimensions ,dragInfo, watermarkText }"
            @scroll-callback="handleScrollCallBack"
        >
            <template #default="defaultScope">
                <slot v-bind="defaultScope"></slot>
            </template>
        </pdf-scroll-document>

        <pdf-skeleton
            class="empty-page"
            v-else
        ></pdf-skeleton>

        <!-- 侧边工具栏 -->
        <!-- <pdf-side-bar
            v-on="$listeners"
            v-bind="{ pageCount, currentPage }"
        >
            <slot name="sidebar-append"></slot>
        </pdf-side-bar> -->
    </div>
</template>

<script>
import PdfScrollDocument from './pdf-scroll-document';
import PdfSkeleton from './pdf-page-render/pdf-skeleton.vue';
import PdfSideBar from './pdf-side-bar';


export default {
    name: 'PdfDocument',
    components: { PdfScrollDocument, PdfSkeleton, PdfSideBar },
    computed: {
        scrollEle () {
            return this.$refs['scroll-document']
        }
    },
    data () {
        return {
            canGrab: false,
            moveXPixel: 0,
            moveYPixel: 0,
            startXPixel: 0,
            startYPixel: 0,
            isHorizonal: false, // 是否水平移动
        }
    },
    props: {
        pages: Array,
        pageCount: Number,
        scale: Number,
        currentPage: Number,
        watermarkText: String,
        isImage: Boolean,
        dimensions: Array,
        isGrab: Boolean,
        dragInfo: Object,
    },
    methods: {
        updateScrollTop (scrollTop) {
            this.$refs?.['scroll-document']?.onUpdateScrollTop?.(scrollTop);
        },

        updateScrollLeft (scrollLeft) {
            this.$refs['scroll-document'].onUpdateScrollLeft(scrollLeft);
        },

        handleMouseMove (e) {
            if (!this.canGrab) return;
            let { scrollTop = 0, scrollLeft = 0 } = this.scrollEle;
            this.moveYPixel = this.startYPixel - e.screenY;
            this.moveXPixel = this.startXPixel - e.screenX;

            Math.abs(this.moveYPixel) > Math.abs(this.moveXPixel) ?
                this.updateScrollTop((scrollTop + this.moveYPixel)) :
                this.updateScrollLeft(scrollLeft + this.moveXPixel)
        },

        handleMouseUp () {
            this.canGrab = false;
        },

        handleMouseDown (e) {
            if (!this.isGrab) return;
            this.canGrab = true;
            this.startYPixel = e.screenY;
            this.startXPixel = e.screenX;
        },

        handleScrollCallBack (top, left) {
            this.$emit('scroll-callback', top, left)
        }
    }
};
</script>

<style lang="less" scoped>
.pdf-document {
    height: 100%;
    margin: 0 auto;
    transform: translate(0);

    &.is-grab {
        cursor: grab;
    }

    &.is-grabbing {
        cursor: grabbing;
    }

    .empty-page {
        width: 793px;
        height: 1100px;
        margin: 0 auto;
        background: #fff;
    }
}
</style>
